Auth = require 'db/auth'
ChangeAvatarPopoverView = require 'views/member/change-avatar-popover-view'
ChangeUserInfoPopoverView = require 'views/member/change-user-info-popover-view'
LargeAvatarView = require 'views/member-menu-profile/large-avatar-view'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
template = require 'views/templates/mini_profile'
track = require 'debug/track'

module.exports = class MemberMiniProfileView extends View
  initialize: ->
    super
    @listenTo @model, 'change', @frameDebounce @render

  viewTitleKey: 'member'
  displayType: 'mod-mini-profile'

  delegateEvents: (events) ->
    miniprofileEvents =
      'click .js-profile': 'showProfile'
      'click .js-edit-profile': 'editProfile'
      'click .js-view-large': 'viewLarge'
      'click .js-change-av': 'changeAvatar'

    super(_.extend(miniprofileEvents, events || @events))

  render: ->
    data = @model.toJSON()
    data.isMe = Auth.isMe(@model)
    data.showEmail = data.email? && !data.isMe
    if !data.email? && @model.get('memberType') == "ghost" && !@loaded
      @loadEmail()

    @$el.html template(data)

    @renderMenu()

    @

  loadEmail: ->
    ModelLoader.loadMemberEmail @model.id
    .then =>
      @loaded = true
    .done()

  showProfile: ->
    track("Mini Profile", "Click Profile")
    return

  editProfile: (e) ->
    Util.stop(e)
    track("Mini Profile", "Click Edit Profile")
    PopOver.pushView
      view: new ChangeUserInfoPopoverView({ @model, @modelCache })
    return

  viewLarge: (e) ->
    Util.stop(e)
    track("Mini Profile", "View Large Avatar")
    PopOver.pushView
      view: new LargeAvatarView({ @model, @modelCache })
    return

  changeAvatar: (e) ->
    Util.stop(e)
    track("Mini Profile", "Change Avatar")
    PopOver.pushView
      view: new ChangeAvatarPopoverView({ @model, @modelCache })
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/member-mini-profile-view.coffee